export enum CommonDetails {
  totalSupplier = "totalSupplier",
  gigaGuru = "gigaGuru",
  sparkingChange = "sparkingChange",
}

export enum CardDetails {
  gigaguruTooltip = "2024 Giga-Guru Recognition Requirements: Consent to share goals and logo, set SMART goals in 3+ pillars or a science-based target, report progress in 3 pillars, complete Scope 1 and 2, and provide new renewable electricity and Scope 3 data.", // nosonar

  sparkingChangeTooltip = "2024 Sparking Change Recognition Requirements: Consent to share goals and logo, set SMART goals in 3+ pillars or a science-based target, report progress in 3 pillars, and provide new Scope 1 and 2 absolute reduction target details." // NOSONAR
}
